<template>
  <div class="container">
    <button
      :class="['slide__control', { active: currentSlide !== 0 }]"
      @click="prevSlide"
    >
      <svgicon icon="arrow" width="30px"></svgicon>
    </button>

    <button
      :class="['slide__control', { active: currentSlide !== slideCount - 1 }]"
      @click="nextSlide"
    >
      <svgicon icon="arrow" width="30px"></svgicon>
    </button>

    <div class="swiper">
      <div
        class="swiper__container"
        :style="`transform: translateX(-${
          currentSlide * 100
        }%); transition: ${transiton}s ease-in-out;`"
      >
        <span v-for="(slide, i) in slides" :key="i" class="slide" ref="slides">
          <slot name="item" :item="{ ...slide, index: i }">{{ slide }}</slot>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Swiper",
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    transiton: {
      type: [Number, String],
      default: 0.4,
    },
    loop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentSlide: 0,
    };
  },
  computed: {
    slideCount() {
      return this.slides.length;
    },
    currentItem() {
      return this.slides[this.currentSlide];
    },
    currentItemNode() {
      return this.$refs?.slides[this.currentSlide];
    },
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.slideCount - 1) this.currentSlide += 1;
      else if (this.loop) {
        // this.currentSlide = 0;
      }

      this.$emit("slide", this.currentSlide + 1);
    },
    prevSlide() {
      if (this.currentSlide > 0) this.currentSlide -= 1;
      else if (this.loop) {
        // this.currentSlide = 0;
      }

      this.$emit("slide", this.currentSlide + 1);
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
  height: 100%;
  width: 100%;

  .slide__control {
    position: absolute;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    color: #fff;
    text-align: center;
    height: 50px;
    transform: translateY(-50%);
    z-index: 100;
    fill: #ccc;
    cursor: auto;

    &:first-of-type {
      left: -50px;
      transform: rotate(90deg) translateX(-50%);
    }
    &:last-of-type {
      right: -50px;
      transform: rotate(-90deg) translateX(50%);
    }

    &:hover {
    }

    &.active {
      fill: $blue;
      cursor: pointer;
    }
  }
}

.swiper {
  display: flex;
  overflow: hidden;
  position: relative;
  height: 100%;

  .swiper__container {
    display: flex;
    width: 100%;

    .slide {
      display: flex;
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      word-break: break-all;
    }
  }
}
</style>
